import { writable } from "svelte/store";
import { uiApi } from "$lib/ui-api";
import { browser } from "$app/environment";

const AUTH_URL = "/z/auth";

export const isLoggedIn = writable(false);
export const isNavOpen = writable(false);

// Use api to check for login status
if (browser) {
  checkLoginStatus().then(({ status }) => isLoggedIn.update(() => status));
}

export async function login(email: string, atCheckout = false, url = `${AUTH_URL}/login`) {
  const resp = await uiApi.getRaw(url, { email, atCheckout });
  if (resp.ok) {
    return await resp.json();
  }
  return {};
}

export async function setNavIsOpen(isOpen: boolean) {
  isNavOpen.update(() => isOpen);
}

export async function loginWithPassword(email: string, password: string) {
  const url = `${AUTH_URL}/login-pw`;
  return await uiApi.postRaw(url, { email, password, atCheckout: false });
}

let checkControl: AbortController | undefined;
export async function checkExists(email: string) {
  if (checkControl) {
    checkControl.abort("Check email exist call aborted");
  }
  checkControl = new AbortController();
  try {
    const baseUrl = window.location.origin;
    const relativeUrl = `${AUTH_URL}/check`;
    const url = new URL(relativeUrl, baseUrl);
    url.searchParams.append("email", email);
    const resp = await fetch(url, { signal: checkControl.signal });
    return await resp.json();
  } catch (err) {
    console.error(err);
    return {};
  } finally {
    checkControl = undefined;
  }

  // const resp = await uiApi.getRaw(`${URL}/check`, { email });
  // if (resp.ok) {
  //   return await resp.json();
  // }
  // return {};
}
// Make sure to catch Error in UI
export async function logout() {
  const response = await uiApi.deleteRaw(`${AUTH_URL}/logout`, "");
  isLoggedIn.update(() => false);
}

export async function checkLoginStatus() {
  return await uiApi.get<{ status: boolean; email?: string }>(`${AUTH_URL}/login-status`);
}

export async function getUserInfo() {
  return new Promise<Promise<Record<string, string>>>(resolve => {
    isLoggedIn.subscribe(v => {
      resolve(
        v ? uiApi.get<Record<string, string>>("/z/auth/details") : new Promise<Record<string, string>>(u => u({}))
      );
    });
  });
}

export async function register(registration: Record<string, any>) {
  return uiApi.postRaw(`${AUTH_URL}/register`, registration);
}

export async function getUserCredit() {
  const resp = await uiApi.getRaw(`${AUTH_URL}/credits-left`);
  if (!resp.ok) {
    throw new Error("Error getting user credit");
  }
  return await resp.json();
}
